import React from "react";
import { Check, MinusCircle } from "lucide-react";
import { FadeUp } from "@/components/landing/cinematic";

const ROWS = [
    { k: "Understand today's business", b: "Call three people. Open five spreadsheets.", a: "One dashboard. 30 seconds." },
    { k: "Know which customer needs attention", b: "Memory. WhatsApp. Guesswork.", a: "Customer Brain ranks every opportunity." },
    { k: "Receive incoming stock", b: "Manual counting. Bin confusion.", a: "Guided receiving with warehouse intelligence." },
    { k: "Decide what to reorder", b: "Instinct over data.", a: "AI predicts replenishment from sales velocity." },
    { k: "Find a product", b: "Ask someone in the warehouse.", a: "Instant product & bin location." },
    { k: "Train a new employee", b: "Weeks of shadowing.", a: "AI-guided workflows from day one." },
    { k: "Answer a business question", b: "Excel. Pivot. Panic.", a: "Ask YugOS Intelligence. Get an answer instantly." },
];

export default function BeforeAfter() {
    return (
        <section className="relative bg-[#f7f3ec] pb-20 lg:pb-36" data-testid="before-after-section">
            <div className="mx-auto max-w-6xl px-5 sm:px-6 lg:px-8">
                <FadeUp>
                    <h2 className="font-display text-[32px] sm:text-5xl font-bold tracking-[-0.03em] text-[#1c1917] leading-[1.06]">
                        From manual operations{" "}
                        <span className="font-editorial font-medium text-[#59524a]">to intelligent operations.</span>
                    </h2>
                </FadeUp>

                <FadeUp delay={0.12}>
                    <div
                        className="mt-10 sm:mt-12 overflow-hidden rounded-2xl sm:rounded-3xl border border-[#1c1917]/10 shadow-[0_28px_70px_-40px_rgba(28,25,23,0.3)]"
                        data-testid="before-after-split"
                    >
                        <div className="grid grid-cols-1 md:grid-cols-2">
                            <div className="flex items-center gap-2.5 bg-[#151310] px-5 sm:px-9 py-4 sm:py-5">
                                <MinusCircle className="h-4 w-4 text-red-400" strokeWidth={2} />
                                <span className="font-display text-[14px] sm:text-[15px] font-bold text-white">Before</span>
                                <span className="font-mono text-[10px] sm:text-[10.5px] uppercase tracking-[0.12em] text-[#6b6459] truncate">
                                    disconnected operations
                                </span>
                            </div>
                            <div className="flex items-center gap-2.5 border-t md:border-t-0 md:border-l border-[#1c1917]/10 bg-white px-5 sm:px-9 py-4 sm:py-5">
                                <Check className="h-4 w-4 text-emerald-500" strokeWidth={2} />
                                <span className="font-display text-[14px] sm:text-[15px] font-bold text-[#1c1917]">After</span>
                                <span className="font-mono text-[10px] sm:text-[10.5px] uppercase tracking-[0.12em] text-[#a29a8e]">
                                    one AI operating system
                                </span>
                            </div>
                        </div>
                        {ROWS.map((r) => (
                            <div key={r.k} className="group grid grid-cols-1 md:grid-cols-2">
                                <div className="border-t border-[#f7f3ec]/[0.08] bg-[#151310] px-5 sm:px-9 py-4 sm:py-5">
                                    <div className="font-mono text-[9.5px] uppercase tracking-[0.18em] text-[#6b6459]">
                                        {r.k}
                                    </div>
                                    <p className="mt-1.5 text-[13.5px] sm:text-[14px] leading-snug text-[#a29a8e]">{r.b}</p>
                                </div>
                                <div className="flex items-center border-t border-[#1c1917]/[0.06] bg-white px-5 sm:px-9 py-4 sm:py-5 md:border-l md:border-l-[#1c1917]/10 transition-colors duration-300 group-hover:bg-emerald-50/50">
                                    <p className="flex items-start gap-2.5 text-[14px] sm:text-[15px] font-medium leading-snug text-[#1c1917]">
                                        <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-500" strokeWidth={2} />
                                        {r.a}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </FadeUp>
            </div>
        </section>
    );
}
